import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Main from './Main';
import Notice from "./Notice";
import NoticeDetail from "./NoticeDetail";
import NoticeWrite from "./NoticeWrite";
import SetPageTrack from './SetPageTrack';
import SinglePage from './SinglePage';
import SinglePageTrack from './SinglePageTrack';
import SelectPage from './SelectPage';
import PaymentPage from "./PaymentPage";
import Signup from './Signup';
import Login from './Login';
import AdminPage from './AdminPage';
import AdManage from './AdManage';
// import AdminLogin from './AdminLogin';
import Withdrawal from './withdrawal';
import HomeTerms from './HomeTerms';
import PrivacyTerms from './PrivacyTerms';
import Explanation from './Explanation';
import AnotherAdminPage from './AnotherAdminPage';
import AnotherAdminLogin from './AnontherAdminLogin';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/Notices" element={<Notice />} />
        <Route path="/Notice/:id" element={<NoticeDetail />} />
        <Route path="/NoticeWrite" element={<NoticeWrite />} />
        <Route path="/SignupAts" element={<Signup />} />
        <Route path="/LoginAts" element={<Login />} />
        <Route path="/SetPageTrack" element={<SetPageTrack />} />
        <Route path="/SinglePage" element={<SinglePage />} />
        <Route path="/SinglePageTrack" element={<SinglePageTrack />} />
        <Route path="/SelectPage" element={<SelectPage />} />
        <Route path="/PaymentPage" element={<PaymentPage />} />
        <Route path="/Adminpage" element={<AdminPage />} />
        <Route path="/AdManage" element={<AdManage />} />
        {/* <Route path="/AdminLogin" element={<AdminLogin />} /> */}
        <Route path="/withdrawal" element={<Withdrawal />} />
        <Route path="/HomeTerms" element={<HomeTerms />} />
        <Route path="/PrivacyTerms" element={<PrivacyTerms />} />
        <Route path="/Explanation" element={<Explanation />} />
        <Route path="/Another_adminpage" element={<AnotherAdminPage />} />
        <Route path="/Another_admin_login" element={<AnotherAdminLogin />} />
      </Routes>
    </BrowserRouter>
  );
}

ReactDOM.render(<App />, document.getElementById('root')); // ReactDOM을 사용하여 App 컴포넌트 렌더링

export default App;
